import React from "react";
import PasswordInput from "./PasswordInput";

// 6-digit numeric PIN field (masked, numeric keypad on mobile)
const PinInput = ({ value, onChange, ...rest }) => (
  <PasswordInput
    value={value}
    onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 6))}
    inputMode="numeric"
    autoComplete="one-time-code"
    pattern="\d{6}"
    title="Enter exactly 6 digits"
    className="h-12 font-semibold tracking-[0.5em] placeholder:font-normal placeholder:tracking-normal"
    {...rest}
  />
);

export default PinInput;
